/* VanillaGoods Food Safety & Recall Center (sections/vg-food-safety.liquid).
   Live FDA food enforcement reports from openFDA (https://open.fda.gov/apis/food/enforcement/), read in the
   visitor's browser: no API key (each visitor gets openFDA's own per-IP allowance). Everything from the API is
   escaped before it is shown. */
(function () {
  'use strict';
  var root = document.querySelector('[data-fs]');
  if (!root) return;

  var API = 'https://api.fda.gov/food/enforcement.json';
  var MAJOR_DAYS = parseInt(root.getAttribute('data-major-days'), 10) || 90;
  var PAGE = parseInt(root.getAttribute('data-page-size'), 10) || 25;
  var DEF = {
    products: root.getAttribute('data-default-products') === 'all' ? 'all' : 'bake',
    hazard: '', cls: '', status: '',
    days: root.getAttribute('data-list-days') || '365', q: ''
  };
  var MAX_SKIP = 25000;                       // openFDA's paging limit

  // words in a product description that make a recall relevant to baking and desserts. Kept to product words
  // (not common ingredients like sugar or butter) because many FDA descriptions include a full ingredient list.
  var BAKE = ['flour', 'flours', 'cake', 'cakes', 'cookie', 'cookies', 'bread', 'breads', 'bagel', 'bagels', 'muffin',
    'muffins', 'brownie', 'brownies', 'pie', 'pies', 'pastry', 'pastries', 'croissant', 'croissants', 'donut', 'donuts',
    'doughnut', 'doughnuts', 'cupcake', 'cupcakes', 'cheesecake', 'cheesecakes', 'tart', 'tarts', 'scone', 'scones',
    'biscuit', 'biscuits', 'waffle', 'waffles', 'pancake', 'pancakes', 'dough', 'batter', 'baking', 'bakery',
    'chocolate', 'chocolates', 'cocoa', 'cacao', 'vanilla', 'frosting', 'icing', 'sprinkles', 'candy', 'candies',
    'confection', 'confections', 'dessert', 'desserts', 'pudding', 'puddings', 'custard', 'gelato', 'sorbet',
    'ice cream', 'almond', 'almonds', 'pecan', 'pecans', 'walnut', 'walnuts', 'hazelnut', 'hazelnuts', 'pistachio',
    'pistachios', 'cashew', 'cashews', 'cinnamon', 'nutmeg', 'cardamom', 'cloves', 'allspice', 'caramel',
    'marshmallow', 'marshmallows', 'granola', 'fudge', 'toffee', 'praline', 'meringue', 'macaron', 'macarons',
    'cannoli', 'baklava', 'strudel', 'danish', 'churro', 'churros', 'babka', 'brioche', 'cobbler', 'crumble',
    'shell eggs'];
  var BAKE_RX = new RegExp('\\b(' + BAKE.map(function (w) { return w.replace(/ /g, '\\s+'); }).join('|') + ')\\b', 'i');

  function anyOf(field, list) {
    return field + ':(' + list.map(function (w) { return w.indexOf(' ') < 0 ? w : '"' + w.replace(/ /g, '+') + '"'; }).join('+') + ')';
  }
  var HAZ_QUERY = {
    allergen: 'reason_for_recall:(undeclared+allergen+allergens+declared+declare+declares+omitted)+AND+' + anyOf('reason_for_recall', ['allergen', 'allergens',
      'milk', 'egg', 'eggs', 'wheat', 'soy', 'soybean', 'soybeans', 'peanut', 'peanuts', 'tree nut', 'tree nuts', 'almond',
      'almonds', 'walnut', 'walnuts', 'pecan', 'pecans', 'cashew', 'cashews', 'pistachio', 'pistachios', 'hazelnut',
      'hazelnuts', 'macadamia', 'sesame', 'fish', 'shellfish', 'shrimp', 'crab', 'lobster', 'sulfite', 'sulfites']),
    germs: anyOf('reason_for_recall', ['salmonella', 'listeria', 'monocytogenes', 'coli', 'e.coli', 'botulinum', 'botulism', 'cereus',
      'cronobacter', 'norovirus', 'hepatitis', 'staphylococcus', 'shigella', 'cyclospora', 'vibrio']),
    foreign: anyOf('reason_for_recall', ['metal', 'plastic', 'glass', 'rubber', 'wood', 'stone', 'stones', 'fragment',
      'fragments', 'foreign']),
    chemical: anyOf('reason_for_recall', ['lead', 'arsenic', 'cadmium', 'mercury', 'aflatoxin', 'mycotoxin', 'patulin',
      'pesticide', 'pesticides', 'chemical', 'unapproved', 'nitrofuran', 'nitrofurans']),
    mold: anyOf('reason_for_recall', ['mold', 'moldy', 'mould', 'molds'])
  };
  var ALLERGENS = [
    ['Milk', /\b(milk|dairy|whey|casein|caseinate|lactose)\b/i],
    ['Egg', /\beggs?\b/i],
    ['Wheat', /\bwheat\b/i],
    ['Soy', /\bsoy(bean)?s?\b/i],
    ['Peanut', /\bpeanuts?\b/i],
    ['Tree nuts', /\b(tree ?nuts?|almonds?|walnuts?|pecans?|cashews?|pistachios?|hazelnuts?|macadamias?|brazil nuts?|pine nuts?)\b/i],
    ['Sesame', /\bsesame\b/i],
    ['Fish', /\b(fish|anchov(y|ies)|tuna|salmon|cod)\b/i],
    ['Shellfish', /\b(shellfish|shrimp|crab|lobster|crustacean)\b/i],
    ['Sulfites', /\bsul(f|ph)ites?\b/i],
    ['Color additive', /\b(yellow|red|blue)\s*(no\.?\s*|#\s*)?\d+|\bfd&c\b/i]
  ];
  var GERMS = [
    ['Listeria', /listeria/i], ['Salmonella', /salmonella/i], ['E. coli', /\be\.?\s?coli\b|\bstec\b|o157/i],
    ['Botulism risk', /botulin|botulism/i], ['Bacillus cereus', /cereus/i], ['Cronobacter', /cronobacter/i],
    ['Norovirus', /norovirus/i], ['Hepatitis A', /hepatitis/i], ['Staph', /staphylococc/i], ['Cyclospora', /cyclospora/i]
  ];

  // ------------------------------------------------------------------ helpers
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function ymd(d) {
    return d.getFullYear() + ('0' + (d.getMonth() + 1)).slice(-2) + ('0' + d.getDate()).slice(-2);
  }
  function daysAgo(n) { var d = new Date(); d.setDate(d.getDate() - n); return d; }
  function niceDate(s) {
    s = String(s || '').replace(/-/g, '');
    if (!/^\d{8}$/.test(s)) return '';
    var d = new Date(Date.UTC(+s.slice(0, 4), +s.slice(4, 6) - 1, +s.slice(6, 8), 12));
    return d.toLocaleDateString('en-US', { timeZone: 'UTC', month: 'short', day: 'numeric', year: 'numeric' });
  }
  function allCaps(s) {
    var letters = s.replace(/[^A-Za-z]/g, '');
    return letters.length > 12 && letters === letters.toUpperCase();
  }
  function tidy(s) {                       // many FDA descriptions are ALL CAPS: show them in sentence case
    s = String(s || '').replace(/\s+/g, ' ').trim();
    if (!allCaps(s)) return s;
    return s.toLowerCase()
      .replace(/(^|[.!?;:]\s+)([a-z])/g, function (m, a, b) { return a + b.toUpperCase(); })
      .replace(/\b(upc|fda|usda|usa|sku)\b/gi, function (m) { return m.toUpperCase(); });
  }
  function firmName(s) {                   // "TODD'S SEEDS LLC" -> "Todd's Seeds LLC"
    s = String(s || '').replace(/\s+/g, ' ').trim();
    if (s !== s.toUpperCase()) return s;
    return s.toLowerCase().replace(/(^|[\s\-\/(&])([a-z])/g, function (m, a, b) { return a + b.toUpperCase(); })
      .replace(/\b(Llc|Inc|Usa|Us|Dba|Ltd|Co-Op)\b/g, function (m) {
        return { Llc: 'LLC', Inc: 'Inc', Usa: 'USA', Us: 'US', Dba: 'DBA', Ltd: 'Ltd', 'Co-Op': 'Co-op' }[m];
      });
  }
  // plain headline from FDA's long product text: the product name before sizes, packaging, UPCs and ingredients
  function headline(s, n) {
    n = n || 70;
    s = tidy(String(s || '').replace(/^(product|generic name|brand name)\s*:\s*/i, ''));
    var cut = s.split(/\s*(?:;|\.\s|\(|\bUPC\b|\bnet\s*wt\b|\bnet weight\b|\bingredients?\s*:|\b(?:packag(?:ed|ing)|packed|in an?|sold as)\b|\bkeep (?:refrigerated|frozen)\b|\b\d+(?:\.\d+)?\s*(?:oz|lb|lbs|g|kg|ml|fl)\b|\bcontains\s*:|\bdistributed by\b|\bmanufactured by\b|\bsold in\b|\bis\b|\bare\b|\bshelf life\b)/i)[0];
    cut = cut.replace(/[\s,:\-\u2013]+$/, '');
    if (cut.length < 4) cut = s;
    if (cut === cut.toUpperCase() && /[A-Z]{3}/.test(cut)) cut = firmName(cut);
    if (cut.length > n) cut = cut.slice(0, n).replace(/\s+\S*$/, '').replace(/[\s,:\-\u2013&]+$/, '') + '\u2026';
    return cut;
  }
  function codesIn(t) {
    t = String(t || '');
    var out = { upc: [], lot: [], dates: [] }, m, rx;
    function add(k, v) { v = v.replace(/\s+/g, ' ').replace(/^[\s.,;:]+|[\s.,;:]+$/g, ''); if (v && out[k].indexOf(v) < 0 && out[k].length < 8) out[k].push(v); }
    rx = /\bUPCs?(?:\s*code)?\s*[:#]?\s*((?:\d[\d\s-]{9,18}\d)(?:\s*(?:,|and|&)\s*\d[\d\s-]{9,18}\d)*)/gi;
    while ((m = rx.exec(t))) m[1].split(/\s*(?:,|and|&)\s*/).forEach(function (u) { var d = u.replace(/\D/g, ''); if (d.length >= 11 && d.length <= 14) add('upc', u); });
    rx = /\b(?:lot|batch)(?:\s*codes?|\s*numbers?|\s*#|#)?\s*[:\s]\s*([A-Z0-9][A-Z0-9\/\-]{2,20}(?:\s*(?:,|and)\s*[A-Z0-9][A-Z0-9\/\-]{2,20}){0,5})/gi;
    while ((m = rx.exec(t))) add('lot', m[1]);
    rx = /\b(?:best[- ]by|best if used by|best before|use[- ]by|sell[- ]by|exp(?:iration)?(?:\s*date)?)\s*[:\s]\s*(?:[A-Z]{3,9}[ \/.-]?\d{1,2}[ ,\/.-]+\d{2,4}|\d{1,2}[\/.-]\d{1,2}[\/.-]\d{2,4}|\d{1,2} [A-Z]{3,9} \d{2,4}|[A-Z]{3,9}[ \/-]\d{4})/gi;
    while ((m = rx.exec(t))) add('dates', m[0]);
    return out;
  }
  var CODE_TIP = '<details class="fs-tip"><summary>Where do I find these on the package?</summary><p>The <b>UPC</b> is the number printed ' +
    'under the barcode. <b>Lot codes</b> and <b>best-by or use-by dates</b> are usually stamped or printed on the top, bottom, ' +
    'side or back of the package, often near each other. For meat and poultry, the <b>EST. number</b> is inside the round ' +
    'USDA mark of inspection. If your package matches, treat it as recalled.</p></details>';
  function codesBlock(c, est) {
    var rows = [];
    if (c.upc && c.upc.length) rows.push('<dt>UPC</dt><dd>' + c.upc.map(esc).join('<br>') + '</dd>');
    if (c.lot && c.lot.length) rows.push('<dt>Lot / batch</dt><dd>' + c.lot.map(esc).join('<br>') + '</dd>');
    if (c.dates && c.dates.length) rows.push('<dt>Dates</dt><dd>' + c.dates.map(esc).join('<br>') + '</dd>');
    if (est && c.est && c.est.length) rows.push('<dt>EST. number</dt><dd>' + c.est.map(esc).join('<br>') + '</dd>');
    return rows.length ? '<div class="fs-codes"><p class="fs-codes-h">Check your package for</p><dl class="fs-kv">' + rows.join('') + '</dl>' + CODE_TIP + '</div>' : '';
  }
  function bakeRelated(r) {                // judged on the product name, not its ingredient list
    return BAKE_RX.test(String(r.product_description || '').split(/ingredients?\s*:|contains\s*:|allergens?\s*:/i)[0]);
  }
  function hazards(r) {
    var t = r.reason_for_recall || '', out = [];
    if (/undeclared|allergen|not (declared|listed|labeled)|does not declare|omitted/i.test(t)) {
      var al = ALLERGENS.filter(function (a) { return a[1].test(t); }).map(function (a) { return a[0]; });
      if (al.length) out.push({ k: 'allergen', label: 'Undeclared ' + al.join(', ').toLowerCase() });
      else if (/allergen/i.test(t)) out.push({ k: 'allergen', label: 'Undeclared allergen' });
      else out.push({ k: 'other', label: 'Undeclared ingredient' });
    }
    GERMS.forEach(function (g) { if (g[1].test(t)) out.push({ k: 'germ', label: g[0] }); });
    if (/\b(metal|plastic|glass|rubber|wood|stones?|fragments?|foreign (material|object|matter))\b/i.test(t)) out.push({ k: 'foreign', label: 'Foreign object' });
    if (/\b(arsenic|cadmium|mercury)\b|\blead\b(?!\s+to\b)/i.test(t)) out.push({ k: 'chem', label: 'Heavy metals' });
    if (/aflatoxin|mycotoxin|patulin/i.test(t)) out.push({ k: 'chem', label: 'Mycotoxin' });
    if (/\bmou?lds?\b|\bmou?ldy\b/i.test(t)) out.push({ k: 'chem', label: 'Mold' });
    if (/unapproved|not approved|pesticide|nitrofuran|tadalafil|sildenafil|dmaa|phenibut/i.test(t)) out.push({ k: 'chem', label: 'Unapproved substance' });
    if (/nutrition facts|nutrients|misbrand/i.test(t)) out.push({ k: 'other', label: 'Labeling error' });
    if (/under-?process|improperly (processed|sealed|pasteuri[sz]ed)|temperature abuse|\bseals?\b|swoll?en|spoil|eviscerat|histamine/i.test(t)) out.push({ k: 'other', label: 'Processing problem' });
    return out;
  }
  function chips(list) {
    return list.map(function (h) { return '<span class="fs-chip fs-chip--' + h.k + '">' + esc(h.label) + '</span>'; }).join('');
  }
  function clsBadge(c) {
    var n = (String(c || '').match(/I{1,3}$/) || [''])[0];
    return n ? '<span class="fs-cls fs-cls--' + n.length + '" title="FDA ' + esc(c) + ' recall">Class ' + n + '</span>' : '';
  }
  function place(r) { return [r.city, r.state, r.country && r.country !== 'United States' ? r.country : ''].filter(Boolean).join(', '); }

  // ------------------------------------------------------------------ openFDA queries
  function search(f) {
    var p = [];
    if (f.days && f.days !== 'all') {
      var tomorrow = daysAgo(-1);
      p.push('report_date:[' + ymd(daysAgo(+f.days)) + '+TO+' + ymd(tomorrow) + ']');
    }
    if (f.cls) p.push('classification:"Class+' + f.cls + '"');
    if (f.status) p.push('status:"' + f.status + '"');
    if (f.products === 'bake') p.push(anyOf('product_description', BAKE));
    if (f.hazard && HAZ_QUERY[f.hazard]) p.push(HAZ_QUERY[f.hazard]);
    var w = String(f.q || '').toLowerCase().replace(/[\u2018\u2019]/g, "'").replace(/[^a-z0-9' ]+/g, ' ').trim()
      .split(/\s+/).map(function (x) { return x.replace(/^'+|'+$/g, ''); })
      .filter(function (x) { return x.length > 1; }).slice(0, 6);
    if (w.length) {
      var last = w.length - 1;                           // search-as-you-type: "choc" finds chocolate
      if (w[last].length >= 3 && w[last].indexOf("'") < 0) w[last] += '*';
      var all = '(' + w.join('+AND+') + ')';
      p.push('(product_description:' + all + '+OR+reason_for_recall:' + all + '+OR+recalling_firm:' + all + ')');
    }
    return p.join('+AND+');
  }
  function url(f, limit, skip) {
    var s = search(f);
    return API + '?' + (s ? 'search=' + s + '&' : '') + 'sort=report_date:desc&limit=' + limit + (skip ? '&skip=' + skip : '');
  }
  var cache = {};
  function get(u) {
    if (cache[u]) return cache[u];
    var p = fetch(u).then(function (r) {
      if (r.status === 404) return { meta: { results: { total: 0 } }, results: [] };   // openFDA: "No matches found"
      if (!r.ok) throw new Error('openFDA ' + r.status);
      return r.json();
    });
    cache[u] = p;
    p.catch(function () { delete cache[u]; });
    return p;
  }
  function total(j) { return (j && j.meta && j.meta.results && j.meta.results.total) || 0; }

  var errBox = '<p class="fs-err">We could not reach the FDA data just now. Try again in a minute, or see the ' +
    '<a href="https://www.fda.gov/safety/recalls-market-withdrawals-safety-alerts" target="_blank" rel="noopener">FDA recalls page</a>.</p>';

  // ------------------------------------------------------------------ stats + major recalls
  var majorBox = root.querySelector('[data-fs-major]');
  var majorMore = root.querySelector('[data-fs-major-more]');
  var majorCount = root.querySelector('[data-fs-major-count]');
  var majorFilter = root.querySelectorAll('[data-fs-major-filter]');
  var majorEvents = [], majorShowAll = false, majorBakeOnly = false;

  function setStat(name, value) {
    var el = root.querySelector('[data-fs-stat="' + name + '"]');
    if (el) el.textContent = value;
  }
  function groupEvents(results) {
    var map = {}, order = [];
    results.forEach(function (r) {
      var id = r.event_id || r.recall_number;
      var ev = map[id];
      if (!ev) {
        ev = map[id] = { id: id, firm: r.recalling_firm, where: place(r), date: r.report_date, start: r.recall_initiation_date,
          status: r.status, reason: r.reason_for_recall, dist: r.distribution_pattern, cls: r.classification,
          products: [], bake: false, haz: {} };
        order.push(ev);
      }
      if (r.report_date > ev.date) ev.date = r.report_date;
      if (r.status === 'Ongoing') ev.status = 'Ongoing';
      ev.products.push(r);
      if (bakeRelated(r)) ev.bake = true;
      hazards(r).forEach(function (h) { ev.haz[h.label] = h; });
    });
    order.forEach(function (ev) { ev.haz = Object.keys(ev.haz).map(function (k) { return ev.haz[k]; }); });
    return order.sort(function (a, b) { return a.date < b.date ? 1 : a.date > b.date ? -1 : (b.bake - a.bake); });
  }
  function eventCard(ev) {
    var p0 = ev.products[0] || {}, more = ev.products.length - 1;
    var list = ev.products.map(function (r) {
      return '<li><span class="fs-prod">' + esc(tidy(r.product_description)) + '</span>' + codesBlock(codesIn(r.code_info + ' ' + r.product_description)) +
        (r.code_info ? '<span class="fs-code"><b>Codes:</b> ' + esc(r.code_info) + '</span>' : '') +
        '<span class="fs-code"><b>Recall #</b> ' + esc(r.recall_number) + '</span></li>';
    }).join('');
    return '<article class="fs-card' + (ev.bake ? ' is-bake' : '') + '">' +
      '<div class="fs-card-top">' + clsBadge(ev.cls) +
      (ev.bake ? '<span class="fs-bake">Baking &amp; dessert</span>' : '') +
      '<span class="fs-date">' + esc(niceDate(ev.date)) + '</span></div>' +
      '<h3 class="fs-card-h">' + esc(headline(p0.product_description)) + '</h3>' +
      '<p class="fs-card-prod">' + esc(firmName(ev.firm)) + (ev.where ? ' \u00b7 ' + esc(ev.where) : '') + '</p>' +
      (more > 0 ? '<p class="fs-card-more">+ ' + more + ' more product' + (more > 1 ? 's' : '') + ' in this recall</p>' : '') +
      '<p class="fs-card-why"><b>Why:</b> ' + esc(tidy(ev.reason)) + '</p>' +
      '<div class="fs-chips">' + chips(ev.haz) + '</div>' +
      '<details class="fs-det"><summary>Products, codes &amp; where it was sold</summary>' +
      '<dl class="fs-kv"><dt>Recalling firm</dt><dd>' + esc(firmName(ev.firm)) + (ev.where ? ' (' + esc(ev.where) + ')' : '') + '</dd>' +
      '<dt>Sold</dt><dd>' + esc(tidy(ev.dist)) + '</dd>' +
      '<dt>Status</dt><dd>' + esc(ev.status) + '</dd>' +
      (ev.start ? '<dt>Recall started</dt><dd>' + esc(niceDate(ev.start)) + '</dd>' : '') +
      '</dl><ul class="fs-prods">' + list + '</ul></details></article>';
  }
  function renderMajor() {
    var list = majorBakeOnly ? majorEvents.filter(function (e) { return e.bake; }) : majorEvents;
    var shown = majorShowAll ? list : list.slice(0, 9);
    majorBox.innerHTML = shown.length ? shown.map(eventCard).join('') :
      '<p class="fs-empty">No Class I ' + (majorBakeOnly ? 'baking or dessert ' : '') + 'food recalls were reported in the last ' + MAJOR_DAYS + ' days.</p>';
    majorBox.setAttribute('aria-busy', 'false');
    if (majorMore) {
      majorMore.hidden = list.length <= 9;
      majorMore.textContent = majorShowAll ? 'Show fewer' : 'Show all ' + list.length + ' major recalls';
      majorMore.setAttribute('aria-expanded', majorShowAll ? 'true' : 'false');
    }
    if (majorCount) majorCount.textContent = list.length + ' recall' + (list.length === 1 ? '' : 's');
  }
  function loadMajor() {
    var u = url({ days: String(MAJOR_DAYS), cls: 'I' }, 1000, 0);
    return get(u).then(function (j) {
      var res = j.results || [];
      majorEvents = groupEvents(res);
      setStat('major', majorEvents.length);
      setStat('major-products', res.length);
      setStat('major-bake', majorEvents.filter(function (e) { return e.bake; }).length);
      setStat('ongoing', majorEvents.filter(function (e) { return e.status === 'Ongoing'; }).length);
      var upd = j.meta && j.meta.last_updated;
      var el = root.querySelector('[data-fs-updated]');
      if (el && upd) el.textContent = niceDate(upd);
      renderMajor();
    }).catch(function () {
      majorBox.innerHTML = errBox;
      majorBox.setAttribute('aria-busy', 'false');
    });
  }
  if (majorMore) majorMore.addEventListener('click', function () { majorShowAll = !majorShowAll; renderMajor(); });
  Array.prototype.forEach.call(majorFilter, function (b) {
    b.addEventListener('click', function () {
      majorBakeOnly = b.getAttribute('data-fs-major-filter') === 'bake';
      Array.prototype.forEach.call(majorFilter, function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
      majorShowAll = false;
      renderMajor();
    });
  });

  // ------------------------------------------------------------------ all enforcement reports
  var form = root.querySelector('[data-fs-form]');
  var listBox = root.querySelector('[data-fs-list]');
  var countEl = root.querySelector('[data-fs-count]');
  var moreBtn = root.querySelector('[data-fs-more]');
  var state = { f: {}, skip: 0, total: 0, shown: 0, seq: 0 };
  var KEYS = ['products', 'hazard', 'cls', 'status', 'days', 'q'];

  function readUrl() {
    var f = {}, sp;
    try { sp = new URLSearchParams(location.search); } catch (e) { sp = null; }
    KEYS.forEach(function (k) {
      var v = sp && sp.get('fs_' + k);
      f[k] = v != null ? v : DEF[k];
    });
    return f;
  }
  function writeUrl(f) {
    if (!window.history || !history.replaceState) return;
    try {
      var sp = new URLSearchParams(location.search);
      KEYS.forEach(function (k) { if (f[k] !== DEF[k] && f[k] !== '') sp.set('fs_' + k, f[k]); else sp.delete('fs_' + k); });
      var qs = sp.toString();
      history.replaceState(null, '', location.pathname + (qs ? '?' + qs : '') + location.hash);
    } catch (e) { /* ignore */ }
  }
  function formToState() {
    var f = {};
    KEYS.forEach(function (k) { var el = form.elements[k]; f[k] = el ? String(el.value).trim() : DEF[k]; });
    return f;
  }
  function stateToForm(f) {
    KEYS.forEach(function (k) {
      var el = form.elements[k];
      if (!el) return;
      el.value = f[k];
      if (el.tagName === 'SELECT' && el.value !== f[k]) { el.value = DEF[k]; f[k] = DEF[k]; }
    });
  }
  function row(r) {
    var hz = hazards(r);
    return '<article class="fs-row' + (bakeRelated(r) ? ' is-bake' : '') + '">' +
      '<div class="fs-row-meta">' + clsBadge(r.classification) +
      '<span class="fs-status fs-status--' + esc(String(r.status || '').toLowerCase()) + '">' + esc(r.status) + '</span>' +
      '<span class="fs-date">' + esc(niceDate(r.report_date)) + '</span></div>' +
      '<div class="fs-row-main"><h3 class="fs-row-h">' + esc(headline(r.product_description)) + '</h3>' +
      '<p class="fs-row-firm">' + esc(firmName(r.recalling_firm)) + (place(r) ? ' \u00b7 ' + esc(place(r)) : '') + '</p>' +
      '<p class="fs-row-why">' + esc(tidy(r.reason_for_recall)) + '</p>' +
      (hz.length ? '<div class="fs-chips">' + chips(hz) + '</div>' : '') +
      '<details class="fs-det"><summary>Details &amp; codes</summary>' + codesBlock(codesIn(r.code_info + ' ' + r.product_description)) +
      '<dl class="fs-kv"><dt>Full FDA description</dt><dd>' + esc(tidy(r.product_description)) + '</dd>' +
      '<dt>Recall number</dt><dd>' + esc(r.recall_number) + '</dd>' +
      (r.product_quantity ? '<dt>Quantity</dt><dd>' + esc(tidy(r.product_quantity)) + '</dd>' : '') +
      (r.code_info ? '<dt>Codes / lots</dt><dd>' + esc(r.code_info) + '</dd>' : '') +
      (r.distribution_pattern ? '<dt>Sold</dt><dd>' + esc(tidy(r.distribution_pattern)) + '</dd>' : '') +
      (r.recall_initiation_date ? '<dt>Recall started</dt><dd>' + esc(niceDate(r.recall_initiation_date)) + '</dd>' : '') +
      (r.center_classification_date ? '<dt>Classified by FDA</dt><dd>' + esc(niceDate(r.center_classification_date)) + '</dd>' : '') +
      (r.termination_date ? '<dt>Closed</dt><dd>' + esc(niceDate(r.termination_date)) + '</dd>' : '') +
      (r.voluntary_mandated ? '<dt>Type</dt><dd>' + esc(r.voluntary_mandated) + '</dd>' : '') +
      '</dl></details></div></article>';
  }
  function setCount() {
    if (!countEl) return;
    countEl.textContent = state.total ? 'Showing ' + state.shown.toLocaleString() + ' of ' + state.total.toLocaleString() + ' reports' : '';
  }
  function loadList(reset) {
    if (reset) {
      state.f = formToState();
      state.skip = 0; state.shown = 0;
      writeUrl(state.f);
      listBox.innerHTML = '';
    }
    var seq = ++state.seq;
    listBox.setAttribute('aria-busy', 'true');
    if (moreBtn) moreBtn.disabled = true;
    return get(url(state.f, PAGE, state.skip)).then(function (j) {
      if (seq !== state.seq) return;                     // a newer search started meanwhile
      var res = j.results || [];
      state.total = total(j);
      state.skip += PAGE;
      state.shown += res.length;
      if (!res.length && reset) {
        listBox.innerHTML = '<p class="fs-empty">No enforcement reports match these filters. Try a longer period or "All foods".</p>';
      } else {
        listBox.insertAdjacentHTML('beforeend', res.map(row).join(''));
      }
      setCount();
      if (moreBtn) {
        moreBtn.hidden = state.shown >= state.total || state.skip >= MAX_SKIP;
        moreBtn.disabled = false;
      }
      listBox.setAttribute('aria-busy', 'false');
    }).catch(function () {
      if (seq !== state.seq) return;
      if (reset) listBox.innerHTML = errBox; else listBox.insertAdjacentHTML('beforeend', errBox);
      if (moreBtn) { moreBtn.hidden = true; moreBtn.disabled = false; }
      listBox.setAttribute('aria-busy', 'false');
    });
  }
  if (form && listBox) {
    stateToForm(readUrl());
    var t;
    form.addEventListener('change', function (e) { if (e.target.name !== 'q') loadList(true); });
    form.addEventListener('input', function (e) {
      if (e.target.name !== 'q') return;
      clearTimeout(t);
      t = setTimeout(function () { loadList(true); }, 450);
    });
    form.addEventListener('submit', function (e) { e.preventDefault(); clearTimeout(t); loadList(true); });
    form.addEventListener('reset', function () {
      setTimeout(function () { stateToForm(DEF); loadList(true); }, 0);
    });
    if (moreBtn) moreBtn.addEventListener('click', function () { loadList(false); });
  }

  // ------------------------------------------------------------------ glossary search
  var gq = root.querySelector('[data-fs-gl-search]');
  var gl = root.querySelector('[data-fs-glossary]');
  if (gq && gl) {
    gq.addEventListener('input', function () {
      var q = gq.value.toLowerCase().trim(), any = false;
      Array.prototype.forEach.call(gl.querySelectorAll('.fs-gl-letter'), function (sec) {
        var hit = 0;
        Array.prototype.forEach.call(sec.querySelectorAll('.fs-term'), function (t) {
          var ok = !q || (t.getAttribute('data-q') || '').indexOf(q) !== -1;
          t.hidden = !ok; if (ok) hit++;
        });
        sec.hidden = !hit; if (hit) any = true;
      });
      var none = gl.querySelector('[data-fs-gl-none]');
      if (none) none.hidden = any;
    });
  }

  // ------------------------------------------------------------------ latest recall announcements (FDA + USDA-FSIS)
  // assets/vg-recalls-latest.json, refreshed daily by food_safety_recalls.py from the official recall lists
  var latestBox = root.querySelector('[data-fs-latest]');
  var latestMore = root.querySelector('[data-fs-latest-more]');
  var latestCount = root.querySelector('[data-fs-latest-count]');
  var latestForm = root.querySelector('[data-fs-latest-form]');
  var FIRST = window.innerWidth < 750 ? 6 : 12, latestData = {}, LATEST = [], latestN = FIRST, latestUpdated = '';
  var latestP = null;
  function loadLatestData() {
    if (latestP) return latestP;
    var u = root.getAttribute('data-latest-url');
    latestP = u ? fetch(u).then(function (r) { if (!r.ok) throw new Error('latest ' + r.status); return r.json(); })
      .then(function (j) { latestData = j; LATEST = j.items || []; latestUpdated = j.updated || ''; return LATEST; }) : Promise.resolve([]);
    latestP.catch(function () { latestP = null; });
    return latestP;
  }
  // FDA CORE outbreak investigations (in vg-recalls-latest.json since Oct 21 2026); falls back to links when missing
  function invFood(x, unknown) {
    if (unknown) return '<p class="fs-inv-food">Possible food source: not identified yet</p>' +
      '<p class="fs-inv-more">FDA has not named a food yet. We add it here as soon as FDA does.</p>';
    var p = x.product || '', sus = /\(suspect(ed)?\)/i.test(p);
    p = p.replace(/\s*\(suspect(ed)?\)\s*/i, ' ').trim();
    return '<p class="fs-inv-food">' + (sus ? 'Suspected food source (FDA): ' : 'Food source linked by FDA: ') + esc(p) + '</p>' +
      (x.foods && x.foods.length ? '<p class="fs-inv-more"><b>Products named by FDA:</b> ' + esc(x.foods.join('; ')) + '</p>' : '');
  }
  function invStates(x) {
    var s = x.states || [];
    if (!s.length) return '<p class="fs-inv-more fs-inv-states"><b>States with illnesses:</b> ' + esc(x.states_note || 'not published yet') + '</p>';
    return '<p class="fs-inv-more fs-inv-states"><b>States with illnesses (' + s.length + '):</b> ' + esc(s.join(', ')) +
      (x.cdc_url ? ' &middot; <a href="' + esc(x.cdc_url) + '" target="_blank" rel="noopener">CDC notice</a>' : '') + '</p>';
  }
  function renderInvest(o) {
    var box = root.querySelector('[data-fs-invest]');
    if (!box) return;
    var core = 'https://www.fda.gov/food/outbreaks-foodborne-illness/investigations-foodborne-illness-outbreaks';
    var items = (o && o.items) || [];
    if (!items.length) { box.innerHTML = '<p class="fs-empty">See the <a href="' + core + '" target="_blank" rel="noopener">FDA investigations table</a> and <a href="https://www.cdc.gov/foodborne-outbreaks/outbreaks/" target="_blank" rel="noopener">CDC outbreak list</a>.</p>'; return; }
    items = items.slice().sort(function (a, b) { return (a.status === 'Ongoing' ? 0 : 1) - (b.status === 'Ongoing' ? 0 : 1) || (a.date < b.date ? 1 : -1); });
    box.innerHTML = '<ul class="fs-invest-list">' + items.map(function (x) {
      var unknown = /not yet identified/i.test(x.product);
      var cases = /^\d+$/.test(x.cases) ? x.cases + ' illnesses reported' : (/^\d[\d,]*$/.test(x.cases_advisory || '') ? x.cases_advisory + ' illnesses reported (FDA advisory)' : 'Illness count: see advisory');
      return '<li class="fs-inv' + (unknown ? ' is-unknown' : '') + '"><p>FDA investigation #' + esc(x.ref) + ' &middot; posted ' + esc(niceDate(x.date)) + ' &middot; outbreak ' + esc((x.status || '').toLowerCase()) + '</p>' +
        '<h3>' + esc(x.pathogen) + '</h3>' + invFood(x, unknown) + invStates(x) + '<p>' + esc(cases) + '</p>' +
        '<p><a href="' + esc(x.url) + '" target="_blank" rel="noopener">' + (unknown ? 'FDA advice' : 'FDA advisory') + '</a></p></li>';
    }).join('') + '</ul><p class="fs-note">From FDA\'s <a href="' + core + '" target="_blank" rel="noopener">investigations table</a>' + (o.fda_updated ? ' (FDA content current as of ' + esc(o.fda_updated) + ')' : '') + '. Only active investigations are shown. States and food sources are FDA\'s own wording from each outbreak advisory; where FDA has not published them yet, we say so.</p>';
  }
  function itemBake(x) { return BAKE_RX.test(x.title + ' ' + x.product); }
  function levelBadge(x) {
    var l = x.level || '';
    if (x.alert) return '<span class="fs-cls fs-cls--2">Public health alert</span>';
    if (/high|class i$/i.test(l)) return '<span class="fs-cls fs-cls--1">High risk &middot; Class I</span>';
    if (l) return '<span class="fs-cls fs-cls--2">' + esc(l) + '</span>';
    return '';
  }
  function photoBlock(x) {
    var p = (x.photos || [])[0];
    if (!p || !/^https:\/\/www\.fda\.gov\//.test(p.src)) return '';
    return '<figure class="fs-lt-photo"><img src="' + esc(p.src) + '" alt="' + esc(p.alt || ('Product photo: ' + x.title)) +
      '" loading="lazy" decoding="async" referrerpolicy="no-referrer" onerror="this.parentNode.remove()">' +
      '<figcaption>Photo from the official recall notice (FDA)</figcaption></figure>';
  }
  function latestCard(x) {
    var st = x.states && x.states.length ? (x.states[0] === 'Nationwide' ? 'Nationwide' : x.states.join(', ')) : '';
    var co = x.company && x.title.toLowerCase().indexOf(x.company.toLowerCase().split(/[ ,]/)[0]) < 0;
    return '<article class="fs-card fs-lt' + (itemBake(x) ? ' is-bake' : '') + '">' +
      '<div class="fs-card-top"><span class="fs-ag fs-ag--' + esc(x.agency.toLowerCase()) + '">' + (x.agency === 'USDA' ? 'USDA &middot; meat, poultry, eggs' : 'FDA') + '</span>' +
      levelBadge(x) + (x.active ? '' : '<span class="fs-status fs-status--completed">Closed</span>') +
      '<span class="fs-date">' + esc(niceDate(x.date)) + '</span></div>' +
      '<h3 class="fs-card-h">' + esc(x.title) + '</h3>' +
      (co ? '<p class="fs-card-prod">' + esc(x.company) + '</p>' : '') + photoBlock(x) +
      '<div class="fs-chips">' + chips(x.problems || []) + '</div>' +
      '<p class="fs-card-why"><b>Sold in:</b> ' + (st ? esc(st) : 'see the official notice') + '</p>' +
      codesBlock(x.codes || {}, true) +
      '<p class="fs-links"><a class="fs-btn fs-btn--sm" href="' + esc(x.url) + '" target="_blank" rel="noopener">Official recall notice</a>' +
      (x.labels || []).slice(0, 1).map(function (l) { return ' <a class="fs-btn fs-btn--sm fs-btn--ghost" href="' + esc(l) + '" target="_blank" rel="noopener">Product labels (PDF)</a>'; }).join('') +
      '</p></article>';
  }
  function latestFilter() {
    var f = latestForm ? latestForm.elements : {};
    var ag = f.agency ? f.agency.value : '', stv = f.state ? f.state.value : '', bake = f.bake ? f.bake.checked : false;
    return LATEST.filter(function (x) {
      if (ag && x.agency !== ag) return false;
      if (bake && !itemBake(x)) return false;
      if (stv && !(x.states || []).some(function (s) { return s === stv || s === 'Nationwide'; })) return false;
      return true;
    });
  }
  function renderLatest() {
    var list = latestFilter();
    latestBox.innerHTML = list.length ? list.slice(0, latestN).map(latestCard).join('') :
      '<p class="fs-empty">No recall announcements match these filters in the last 90 days.</p>';
    latestBox.setAttribute('aria-busy', 'false');
    if (latestCount) latestCount.textContent = list.length + ' recall' + (list.length === 1 ? '' : 's');
    if (latestMore) { latestMore.hidden = list.length <= latestN; latestMore.textContent = 'Show more recalls (' + (list.length - latestN) + ' more)'; }
  }
  if (latestBox) {
    loadLatestData().then(function () {
      var stSel = latestForm && latestForm.elements.state;
      if (stSel && stSel.options.length < 3) {
        var seen = {};
        LATEST.forEach(function (x) { (x.states || []).forEach(function (s) { if (s !== 'Nationwide') seen[s] = 1; }); });
        Object.keys(seen).sort().forEach(function (s) { var o = document.createElement('option'); o.value = s; o.textContent = s; stSel.appendChild(o); });
      }
      var fdaN = LATEST.filter(function (x) { return x.agency === 'FDA'; }).length;
      setStat('latest', LATEST.length);
      var stale = root.querySelector('[data-fs-stale]');
      if (stale && latestUpdated) { var age = (Date.now() - new Date(latestUpdated.replace('Z', ':00Z')).getTime()) / 3600000; stale.hidden = !(age > 36); }
      renderInvest(latestData.outbreaks);
      var el = root.querySelector('[data-fs-latest-updated]');
      if (el && latestUpdated) el.textContent = new Date(latestUpdated.replace('Z', ':00Z')).toLocaleString('en-US', { month: 'short', day: 'numeric', year: 'numeric', hour: 'numeric', minute: '2-digit' });
      var sum = root.querySelector('[data-fs-latest-sum]');
      if (sum) sum.textContent = fdaN + ' from FDA and ' + (LATEST.length - fdaN) + ' from USDA';
      renderLatest();
    }).catch(function () {
      latestBox.innerHTML = '<p class="fs-err">We could not load the latest recall list just now. See <a href="https://www.fda.gov/safety/recalls-market-withdrawals-safety-alerts" target="_blank" rel="noopener">FDA recalls</a> and <a href="https://www.fsis.usda.gov/recalls" target="_blank" rel="noopener">USDA recalls</a>.</p>';
      latestBox.setAttribute('aria-busy', 'false');
    });
    if (latestForm) latestForm.addEventListener('change', function () { latestN = FIRST; renderLatest(); });
    if (latestMore) latestMore.addEventListener('click', function () { latestN += 24; renderLatest(); });
  }
  else if (root.querySelector('[data-fs-invest]')) {
    // investigations only (/pages/foodborne-outbreak-statistics): same JSON, no recall list
    loadLatestData().then(function () {
      var stale = root.querySelector('[data-fs-stale]');
      if (stale && latestUpdated) { var age = (Date.now() - new Date(latestUpdated.replace('Z', ':00Z')).getTime()) / 3600000; stale.hidden = !(age > 36); }
      renderInvest(latestData.outbreaks);
      var el = root.querySelector('[data-fs-latest-updated]');
      if (el && latestUpdated) el.textContent = new Date(latestUpdated.replace('Z', ':00Z')).toLocaleString('en-US', { month: 'short', day: 'numeric', year: 'numeric', hour: 'numeric', minute: '2-digit' });
    }).catch(function () { renderInvest(null); });
  }

  // ------------------------------------------------------------------ "Is my food recalled?" checker
  var ck = root.querySelector('[data-fs-check]');
  if (ck) {
    var ckIn = ck.querySelector('input'), ckOut = root.querySelector('[data-fs-check-out]'), ckT, ckSeq = 0;
    var words = function (q) {
      return q.toLowerCase().replace(/[\u2018\u2019]/g, "'").replace(/[^a-z0-9' ]+/g, ' ').trim().split(/\s+/)
        .map(function (x) { return x.replace(/^'+|'+$/g, ''); }).filter(function (x) { return x.length > 1; }).slice(0, 6);
    };
    var isCode = function (q) { return /^[\d\s-]+$/.test(q) && q.replace(/\D/g, '').length >= 6; };
    var localHits = function (q) {
      var digits = q.replace(/\D/g, ''), w = words(q);
      return LATEST.filter(function (x) {
        var c = x.codes || {};
        var codes = [].concat(c.upc || [], c.lot || [], c.est || []).join(' ');
        var hay = (x.title + ' ' + x.product + ' ' + x.brand + ' ' + x.company + ' ' + x.reason + ' ' + codes).toLowerCase();
        if (isCode(q)) return (x.product + ' ' + codes).replace(/\D/g, '').indexOf(digits) >= 0;
        return w.length && w.every(function (t) { return hay.indexOf(t) >= 0; });
      });
    };
    var fdaQuery = function (q) {
      var digits = q.replace(/\D/g, '');
      var since = 'report_date:[' + ymd(daysAgo(730)) + '+TO+' + ymd(daysAgo(-1)) + ']';
      if (isCode(q)) {
        if (digits.length < 8) return '';
        var v = [digits];
        if (digits.length === 12) v.push('"' + digits[0] + '+' + digits.slice(1, 6) + '+' + digits.slice(6, 11) + '+' + digits[11] + '"', '"' + digits.slice(0, 6) + '+' + digits.slice(6) + '"');
        return since + '+AND+(' + v.map(function (x) { return 'product_description:' + x + '+OR+code_info:' + x; }).join('+OR+') + ')';
      }
      var w = words(q);
      if (!w.length) return '';
      var all = '(' + w.join('+AND+') + ')';
      return since + '+AND+(product_description:' + all + '+OR+recalling_firm:' + all + ')';
    };
    var hitRow = function (h) {
      return '<li class="fs-hit"><span class="fs-ag fs-ag--' + h.ag.toLowerCase() + '">' + h.ag + '</span> <b>' + esc(h.title) + '</b>' +
        '<span class="fs-hit-meta">' + esc(h.problem) + ' &middot; ' + esc(niceDate(h.date)) + (h.who ? ' &middot; ' + esc(h.who) : '') + '</span>' +
        (h.url ? '<a href="' + esc(h.url) + '"' + (h.official ? ' target="_blank" rel="noopener">Official notice' : '>See codes &amp; details') + '</a>' : '') + '</li>';
    };
    var runCheck = function () {
      var q = ckIn.value.trim(), seq = ++ckSeq;
      if (q.length < 3) { ckOut.innerHTML = ''; ckOut.hidden = true; return; }
      ckOut.hidden = false;
      ckOut.innerHTML = '<p class="fs-check-wait">Checking FDA and USDA recalls&hellip;</p>';
      var fq = fdaQuery(q);
      Promise.all([
        loadLatestData().then(function () { return localHits(q); }).catch(function () { return []; }),
        fq ? get(API + '?search=' + fq + '&sort=report_date:desc&limit=25').then(function (j) { return j.results || []; }).catch(function () { return null; }) : Promise.resolve([])
      ]).then(function (r) {
        if (seq !== ckSeq) return;
        var hits = r[0].map(function (x) {
          return { ag: x.agency, title: x.title, problem: ((x.problems || [])[0] || {}).label || '', date: x.date, who: x.company, url: x.url, official: true };
        });
        var seen = {};
        (r[1] || []).forEach(function (x) {
          var id = x.event_id || x.recall_number;
          if (seen[id]) return;
          seen[id] = 1;
          hits.push({ ag: 'FDA', title: headline(x.product_description), problem: ((hazards(x)[0] || {}).label) || headline(x.reason_for_recall, 50),
            date: x.report_date, who: firmName(x.recalling_firm),
            url: '?fs_q=' + encodeURIComponent(q) + '&fs_products=all&fs_days=730#fs-reports' });
        });
        hits.sort(function (a, b) { return String(b.date).replace(/-/g, '') > String(a.date).replace(/-/g, '') ? 1 : -1; });
        var tail = '<p class="fs-check-note">Always compare the brand, size, lot code, UPC and dates on your package with the recall notice. ' +
          'Official lists: <a href="https://www.fda.gov/safety/recalls-market-withdrawals-safety-alerts" target="_blank" rel="noopener">FDA recalls</a> &middot; ' +
          '<a href="https://www.fsis.usda.gov/recalls" target="_blank" rel="noopener">USDA meat &amp; poultry recalls</a>.</p>';
        if (!hits.length) {
          ckOut.innerHTML = '<p class="fs-check-none"><b>No match for &ldquo;' + esc(q) + '&rdquo; in our copy of recent notices.</b> That does not mean a product is safe: our copy covers FDA and USDA recall announcements from the last 90 days ' +
            'and FDA enforcement reports from the last 2 years, and can lag the agencies. Check the official notice and your package.' + (r[1] === null ? ' The FDA report search did not answer; try again in a minute.' : '') + '</p>' + tail;
          return;
        }
        ckOut.innerHTML = '<p class="fs-check-found"><b>' + hits.length + (r[1] && r[1].length >= 25 ? '+' : '') + ' recall' + (hits.length === 1 ? '' : 's') +
          ' match &ldquo;' + esc(q) + '&rdquo;.</b> A name match alone does not mean your package is recalled: check the codes.</p>' +
          '<ul class="fs-hits">' + hits.slice(0, 12).map(hitRow).join('') + '</ul>' + tail;
      });
    };
    ckIn.addEventListener('input', function () { clearTimeout(ckT); ckT = setTimeout(runCheck, 500); });
    ck.addEventListener('submit', function (e) { e.preventDefault(); clearTimeout(ckT); runCheck(); });
  }

  // start
  if (majorBox) loadMajor();
  if (form && listBox) loadList(true);
  window.VGFoodSafety = { headline: headline, codesIn: codesIn, search: search, url: url, hazards: hazards, bakeRelated: bakeRelated, tidy: tidy, firmName: firmName };
})();
